import styled from 'styled-components'
import { Mono, theme } from '@superhi/design'

export const Wrapper = styled.div`
  &:not(:first-child) {
    margin-top: 40px;
  }

  &:not(:last-child) {
    margin-bottom: 40px;
  }
`

export const Code = styled(Mono).attrs({ level: '2', forwardedAs: 'code' })`
  display: block;
  background-color: ${theme.colors.PALE_BLUE_40};
  padding: 24px;
  overflow: scroll;
  border-radius: 10px;
  tab-size: 2;
`
